import { render, staticRenderFns } from "./PopoverLesson.vue?vue&type=template&id=09de2763&scoped=true"
import script from "./PopoverLesson.vue?vue&type=script&lang=js"
export * from "./PopoverLesson.vue?vue&type=script&lang=js"
import style0 from "./PopoverLesson.vue?vue&type=style&index=0&id=09de2763&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09de2763",
  null
  
)

export default component.exports